import { render, staticRenderFns } from "./addfooddistribution.vue?vue&type=template&id=85afa990&"
import script from "./addfooddistribution.vue?vue&type=script&lang=js&"
export * from "./addfooddistribution.vue?vue&type=script&lang=js&"
import style0 from "./addfooddistribution.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports